export default {"src":"/_next/static/media/plus_icon_n400.7dd2d17e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};